import type { SVGProps } from "react"
import React from "react"

export const UKFlag: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 96,
  height = 64,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 96 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title> UK flag</title>
    <path d="M0 0H96V64H0V0Z" fill="white" />
    <path
      d="M35.965 21.5349L3.93922 0H0V2.21476L28.7934 21.5349H35.965Z"
      fill="#DE2C2C"
    />
    <path
      d="M59.9097 42.4651L92.1379 64H95.9778V61.7852L67.1844 42.4651H59.9097Z"
      fill="#DE2C2C"
    />
    <path
      d="M28.7934 42.4651L0 61.7852V64H3.83988L36.0681 42.4651H28.7934Z"
      fill="#DE2C2C"
    />
    <path
      d="M92.0386 0L60.0129 21.5349H67.1845L95.9778 2.21476V0H92.0386Z"
      fill="#DE2C2C"
    />
    <path
      d="M54.7593 0H41.2185V25.2566H0V38.743H41.2185V63.9996H54.7593V38.743H95.9779V25.2566H54.7593V0Z"
      fill="#DE2C2C"
    />
    <path
      d="M37.4819 63.9998V46.2893L11.2141 63.9998H37.4819Z"
      fill="#03337C"
    />
    <path d="M0 7.14655V21.5348H21.5186L0 7.14655Z" fill="#03337C" />
    <path d="M58.4963 0V17.6115L84.661 0H58.4963Z" fill="#03337C" />
    <path
      d="M95.9779 56.9561V42.4651H74.4593L95.9779 56.9561Z"
      fill="#03337C"
    />
    <path d="M95.9779 21.535V7.04395L74.4593 21.535H95.9779Z" fill="#03337C" />
    <path d="M37.4819 0H11.2141L37.4819 17.6115V0Z" fill="#03337C" />
    <path d="M0 42.4651V56.8534L21.5186 42.4651H0Z" fill="#03337C" />
    <path d="M58.4963 63.9998H84.661L58.4963 46.2893V63.9998Z" fill="#03337C" />
    <path
      d="M0 0V-1H-1V0H0ZM96 0H97V-1H96V0ZM96 64V65H97V64H96ZM0 64H-1V65H0V64ZM0 1H96V-1H0V1ZM95 0V64H97V0H95ZM96 63H0V65H96V63ZM1 64V0H-1V64H1Z"
      fill="#767676"
    />
  </svg>
)
